import Button from 'components/form-elements/buttons/Button'
import Input from 'components/form-elements/input/Input'
import { useRequest } from 'hooks/useRequest'
import { useState } from 'react'
import useToast from 'hooks/useToast';
import { useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';


const StageForgotStep3 = () => {

    const [request] = useRequest()
    const { showToast } = useToast()
    const navigate = useNavigate()
    const query = new URLSearchParams(window.location.search);
    const token = query.get('token')
    const {t} = useTranslate()


    useEffect(() => {
        document.title = 'Şifremi Yenile';
    }, []);

    const [resetPassword, setResetPassword] = useState({
        email: '',
        token: token,
    })

    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')



    const setPassword = () => {
        const validate = () => {
			const upper = /[A-Z]/,
				lower = /[a-z]/,
				number = /[0-9]/,
				special = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
		
			if (newPassword.length >= 8 &&
				upper.test(newPassword) &&
				lower.test(newPassword) &&
				number.test(newPassword) &&
				special.test(newPassword)
			) {
				return true;
			}
		
			return false;
		}
        if (newPassword != confirmPassword) {
			showToast(t('passwordsNotMatch'),'error')
        }
        else if(!validate()) {
			showToast(t('passwordConfirmToast'),'error')
		}else {
            request('/InternalAuth/PasswordReset', {
                method: 'POST',
                data: {
                    email: resetPassword.email,
                    token: token,
                    newPassword: newPassword,
                    confirmPassword: confirmPassword
                },
    
            }).then((res) => {
                if (res?.data) {
                    if (res?.data?.ok) {
                        showToast(t('passwordChanged'), 'success')
                        navigate('/uye-girisi')
                    }
                }
            })
        }
    }


    const handleChange = (e) => {
        setResetPassword((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
    }


    return (
        <div className="d-flex flex-column gap-4  m-auto p-3 register-login-container">
            <Input containerClassName={"mt-5 "}
                className={''} placeholder={t('labelMail')}
                type={'text'} textLabel={t('labelMail')}
                name='email'
                value={resetPassword.email}
                onChange={handleChange}
            />
           <Input
				containerClassName={'inputPhoneClassNameContainer'}
				className={''}
				labelClassName={'stageTwoLabel'}
				placeholder={t('labelPassword')}
				type={'password'}
				textLabel={t('labelPassword')}
				name='password'
				value={newPassword}
				onChange={(e) => setNewPassword(e.target.value)}
			/>
			<Input
				containerClassName={'inputPhoneClassNameContainer'}
				className={''}
				labelClassName={'stageTwoLabel'}
				placeholder={t('labelConfirmPassword')}
				type={'password'}
				textLabel={t('labelConfirmPassword')}
				name='confirmPassword'
				value={confirmPassword}
				onChange={(e) => setConfirmPassword(e.target.value)}
			/>
            <div className='register-container-btnGroup stage3-btn-group'>

                <Button onClick={setPassword} className={"stageTwoBtnRed"} icon={''} text={t('saveBtn')} />
            </div>
        </div>
    )
}

export default StageForgotStep3